export default __webpack_public_path__ + "static/media/hm-sbo-img.2352662a.webp";